import React from "react";
import cn from "classnames";
import styles from "./Community.module.sass";
import Image from "../Image";
import WaitList from "../WaitList";

const Community = () => {
  return (
    <div className={cn("section-pb", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.preview}>
          <Image
            srcSet="/images/content/bowlBranding.png 2x"
            srcSetDark="/images/content/bowlBranding.png 2x"
            src="/images/content/bowlBranding.png"
            srcDark="/images/content/bowlBranding.png"
            alt="Dumbbell"
          />
        </div>
        <div className={cn("stage-small", styles.stage)}>
          Sign up today for early access 🚀
        </div>
        <h2 className={cn("h2", styles.title)}>Join the waitlist today</h2>
        <div className={styles.text}>
          When you join the waitlist, you'll get early access, special perks, and get some serious deals on some grub.
        </div>
        <div className={styles.subscription}>
          <WaitList
            placeholderEmail="Email Address"
            placeholderZip="Zip Code"
          />
        </div>
        <div className={styles.note}>
          We will never spam you, and we'll always protect your private information.
          {/* By click sign in you, you agree with Reffo <a href="/#">terms</a> and{" "}<a href="/#">policies</a>*/}
          
        </div>
      </div>
    </div>
  );
};

export default Community;
